import { IpresentationStateAction } from '../actions/presentationStateAction';
import { CAROUSEL_SLIDER_STATE, ICarouselSliderState } from '../states/presentationStates';
import _ from 'lodash';

const presentationStateReducer = (state: ICarouselSliderState = CAROUSEL_SLIDER_STATE, action: IpresentationStateAction) => {
    switch (action.type) {
        case 'SHOW_FULL_SCREEN_LINK':
            return { ...state, showFullScreenLink: action.value };
        case 'CURRENT_SLIDE_INDEX':
            return { ...state, currentSlideIndex: action.value };
        case 'SLIDE_COUNT':
            return { ...state, slideCount: action.value };
        case 'PRESENTATION_HTML_FRAGMENTS':
            return { ...state, presentationHTMLFragments: {
                            ...state.presentationHTMLFragments,
                            [action.index]: action.value
                        }
                    };
        case 'PRESENTATION_JSON_FRAGMENTS':
            return { ...state, presentationJSONFragments: {
                            ...state.presentationJSONFragments,
                            [action.index]: action.value.bodyText
                        }
                    };
        case 'CHANGE_SLIDE_HEIGHT':
            return { ...state, slideHeight: action.value };
        case 'CHANGE_SLIDE_ZOOM':
            return { ...state, slideZoom: action.value };
        case 'CHANGE_MODAL_STATUS':
            return { ...state, modalStatus: action.value };
        case 'CHANGE_SLIDE_BASE_WIDTH':
            return { ...state, slideBaseWidth: action.value };
        case 'CHANGE_SLIDE_BASE_HEIGHT':
            return { ...state, slideBaseHeight: action.value };
        case 'CHANGE_BODY_SOURCE':
            return { ...state, bodySource: action.value };
        default:
            return state;
    }
};

export default presentationStateReducer;
